import { render, staticRenderFns } from "./SubscriptionNotice.vue?vue&type=template&id=07cc1aca&"
import script from "./SubscriptionNotice.vue?vue&type=script&lang=js&"
export * from "./SubscriptionNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports